var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pieData && _vm.pieData.length > 0)?_c('Chart',{attrs:{"options":_vm.options,"init-options":{ renderer: 'canvas' },"autoresize":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }